module.exports = __webpack_public_path__ + "img/top_bg4.19c37b8b.png";